// extracted by mini-css-extract-plugin
export default {"active":"select_active__3xieZ","checkmark":"select_checkmark__dMXT1"};